/**
 * DocumentOutputSettings Component
 *
 * Generated documents tab: what the company prints on the documents it issues, one section per
 * document type.
 */
import { kebabCase } from 'es-toolkit';
import { OutputDocumentType } from '@insio/shared-types';
import { useFeatureTranslation } from '@/hooks/useFeatureTranslation';
import { DocumentOutputSection } from './document-output/DocumentOutputSection';

export function DocumentOutputSettings() {
  const t = useFeatureTranslation('systemSettings.documentOutput');

  return (
    <div className='space-y-lg'>
      <p className='text-sm text-foreground-muted'>{t('identitySource')}</p>

      {/* One section per generated document type; a new type needs only its `sections` copy. */}
      {Object.values(OutputDocumentType).map(documentType => (
        <DocumentOutputSection
          key={documentType}
          documentType={documentType}
          testId={`document-output-${kebabCase(documentType)}`}
        />
      ))}
    </div>
  );
}
